/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { batchActions } from 'redux-batched-actions';
// material
import { displaySuccessMessage, displayErrorMessage } from '@insticator/insticator-ui';
// utils
import { asyncUpdateAddOnsConfig, asyncGetCode } from 'utils/api/ratings';

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const GET_ADDONS = 'GET_ADDONS';
export const GET_CODE = 'GET_CODE';
export const ADDONS_SETTINGS_CHANGED = 'ADDONS_SETTINGS_CHANGED';
export const UPDATE_ADDONS_SETTING_SUCCESS = 'UPDATE_ADDONS_SETTING_SUCCESS';
export const UPDATE_ADDONS_SETTING_ERROR = 'UPDATE_ADDONS_SETTING_ERROR';
export const DISCARD_ADDONS_SETTINGS = 'DISCARD_ADDONS_SETTINGS';

export const getAddOns = ({siteUUID, data}) =>  ({
  type: GET_ADDONS,
  siteUUID,
  data
});

export const getAddOnsCode = ({siteUUID, productType}) => dispatch => {
  return asyncGetCode({siteUUID, productType})
      .then(response => {
          return dispatch(getCode(response.data))
      }, err => {
          return dispatch(displayErrorMessage(`There was an issue fetching the code.`))
      }
  );
};

const getCode = data =>  ({
  type: GET_CODE,
  data
});

export const discardAddOnsSettings = ({addOnsType, ignoreProperty}) => ({
    type: DISCARD_ADDONS_SETTINGS,
    addOnsType,
    ignoreProperty
})

export const addOnsSettingsChanged = ({addOnsType = null, property, value}) => ({
    type: ADDONS_SETTINGS_CHANGED,
    addOnsType,
    property,
    value
})

export const updateAddOnsSetting = ({path, type, request, configUUID, showSuccessMessage}) => dispatch => {
    return asyncUpdateAddOnsConfig({path, request, configUUID})
        .then(response => {
            if(showSuccessMessage)
                dispatch(displaySuccessMessage('Successfully updated add-on settings.'));
            return dispatch(updateAddOnsSettingSuccess(type, response))
        }, err => {
            dispatch(displayErrorMessage(`There was an issue updating the add-on setting.`));
            return dispatch(updateAddOnsSettingError(type, err));
        }
    );
};

const updateAddOnsSettingSuccess = (type, response) => ({
    type: UPDATE_ADDONS_SETTING_SUCCESS,
    addOnsType: type,
    response
});

const updateAddOnsSettingError = (type, response) => ({
    type: UPDATE_ADDONS_SETTING_ERROR,
    addOnsType: type,
    response
});